const COOLDOWN_MS = 5 * 60 * 1000;
const KEY = "kurb_nag_cooldown_until";

export function setNagCooldown(): void {
  try {
    sessionStorage.setItem(KEY, String(Date.now() + COOLDOWN_MS));
  } catch {}
}

export function isNagOnCooldown(): boolean {
  try {
    const until = Number(sessionStorage.getItem(KEY));
    return Date.now() < until;
  } catch {}
  return false;
}
